const API_BASE_URL_LOCAL = "http://localhost:8080/api";

export const apiUrl = () => {
    return window.REACT_APP_API_URL || process.env.REACT_APP_API_URL || API_BASE_URL_LOCAL;
};
